import type { FC } from 'react';

import { useAppSelector } from 'shared/lib';

import { selectCreditPurposeInfoData } from 'entities/creditForm';
import { selectIsSelectedProductTypeFeatureEnabled } from 'entities/siteSettings';

import { ProductTypeSelection, resolveActiveProductTypeTabTitle } from 'features/ProductTypeSelection';
import { AccordionModalForm, type TCreditPurposeAccordionProps } from 'features/UpdateCreditPurposeInfo';

export const CreditPurposeAccordionModalForm: FC<TCreditPurposeAccordionProps> = (props) => {
  const isProductTypeSelectionEnabled = useAppSelector(selectIsSelectedProductTypeFeatureEnabled);
  const creditPurposeData = useAppSelector(selectCreditPurposeInfoData);
  const productTabTitle = isProductTypeSelectionEnabled
    ? resolveActiveProductTypeTabTitle(creditPurposeData)
    : undefined;

  return (
    <AccordionModalForm
      {...props}
      productCardBlock={isProductTypeSelectionEnabled ? <ProductTypeSelection /> : undefined}
      productTabTitle={productTabTitle}
    />
  );
};
